/* eslint-disable no-underscore-dangle */
const editPreview = (params) => {
  window.location.href = `#/documentos/nuevo/${params?.society?._id}?edit=true`;
};

export default editPreview;
